import { useLocaleState, useRecordContext } from "react-admin";

import LabelAttachedField from "../../unit/LabelAttachedField";
import LabelField from "../../unit/LabelField";
import { Grid } from "@mui/material";

const HoldToResumeDecline = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} md={6} lg={6}>
          <LabelField
            title="Data Recommended"
            value={record.created_at}
            format="date"
            prefix="EST"
          />
          <LabelField title="Recommended By" value={record.sOper} />
          {record.sOverrideNotes && record.sOverrideNotes.length > 0 ? (
            <LabelField
              title="Add Note (Max 150 Characters)"
              value={record.sOverrideNotes}
              format="richtext"
            />
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {record.sComment && record.sComment.length > 0 ? (
            <LabelField
              title="Comment"
              value={record.sComment}
              format="richtext"
            />
          ) : (
            <></>
          )}
          {record.filelist && record.filelist.length > 0 ? (
            <LabelAttachedField list={record.filelist} />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default HoldToResumeDecline;
